// The Valor Tools card (Oct 15 2026): which Valor Tools account this game account is linked to, this world's plan there, the
// guilds, and buttons into Valor Tools (signed in). Shown only when Valor Tools' Admin page switched Valor Web on for the player.
import { Button, Card, CardHead } from "@/kit/primitives";
import { openTools, planWords, useVtMe } from "@/state/vt";
import { worldLabel } from "@/state/session";

export function ValorToolsCard({ wid }: { wid: number | null }) {
  const q = useVtMe(wid);
  const me = q.data;
  if (!wid || !me?.on) return null;
  const go = (to: string) => openTools(wid, to, true);
  return (
    <Card className="vt-card">
      <CardHead title="Valor Tools" aside={worldLabel(wid)} />
      <div className="stack" style={{ gap: "calc(var(--u) * 10)" }}>
        <p style={{ margin: 0, font: "400 var(--fs-body2)/1.45 var(--text)", color: "var(--cream)" }}>
          Linked to <b className="gold">{me.name || "your Valor Tools account"}</b>
        </p>
        <p className="vt-plan" style={{ margin: 0, font: "400 var(--fs-meta)/1.4 var(--text)" }}>{planWords(me.plan)}</p>
        {!!me.guilds?.length && (
          <p className="muted" style={{ margin: 0, font: "400 var(--fs-meta)/1.4 var(--text)" }}>
            Guild{me.guilds.length > 1 ? "s" : ""}: {me.guilds.map((g) => (g.tag ? `[${g.tag}] ${g.name}` : g.name)).join(" · ")}
          </p>
        )}
        <div className="acts" style={{ display: "flex", flexWrap: "wrap", gap: "calc(var(--u) * 8)" }}>
          <Button size="sm" onClick={() => go(`/app/?tab=dashboard&w=${wid}`)}>Dashboard</Button>
          <Button size="sm" kind="steel" onClick={() => go(`/app/?w=${wid}`)}>Planner</Button>
          <Button size="sm" kind="steel" onClick={() => go(`/app/?tab=guild&w=${wid}`)}>Guild</Button>
          <Button size="sm" kind="gold" onClick={() => go(`/app/?tab=dashboard&dt=store&w=${wid}`)}>Store</Button>
        </div>
      </div>
    </Card>
  );
}
